
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kPeHn", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $3db7060391771768$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $3db7060391771768$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)((0, $6bHqX.fetchCommerceRolloutInformation), ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>{
    return newCloudId === lastCloudId;
});
const $3db7060391771768$export$aeaed4e776302908 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const loadCommerceBackendName = async ()=>{
            try {
                const { payload: payload } = await $3db7060391771768$var$memoizedFetchCommerceRolloutInformation({
                    cloudId: cloudId,
                    productKey: $3db7060391771768$export$b65b36d21c9a62a9
                }, {
                    fetch: (0, $f7B1p.cfetch)
                });
                setCommerceBackendName(payload?.commerceBackend ?? null);
            } catch (error) {
                error.message = `useCommerceBackendName: ${error.message}`;
                setError(error);
            } finally{
                setLoading(false);
            }
        };
        loadCommerceBackendName();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceBackendName"] = $3db7060391771768$export$aeaed4e776302908;

});

parcelRegister("iTy4g", function(module, exports) {
/* eslint-disable prefer-const */ /**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $2XqLN = parcelRequire("2XqLN");


var $6bHqX = parcelRequire("6bHqX");


var $kPeHn = parcelRequire("kPeHn");








var $8Jfqx = parcelRequire("8Jfqx");





var $f7B1p = parcelRequire("f7B1p");


var $lf6uD = parcelRequire("lf6uD");

const $9bd75aff27ae6a9e$var$memoizedInvoiceRequests_get_v1 = (0, $2XqLN.default)((0, $8Jfqx.invoiceRequests_get_v1), ([{ headers: { 'X-transaction-account': newTransactionAccountId } }], [{ headers: { 'X-transaction-account': lastTransactionAccountId } }])=>{
    return newTransactionAccountId === lastTransactionAccountId;
});
const $9bd75aff27ae6a9e$export$42fed8667fa5fb1c = ({ skip: skip } = {
    skip: false
})=>{
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [entitlementId, setEntitlementId] = (0, $42omo.useState)(undefined);
    const [invoiceRequestData, setInvoiceRequestData] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const { transactionAccountId: transactionAccountId, subscriptionv2: subscriptionv2, entitlementId: entitlementId } = await (0, $lf6uD.getCurrentEntitlementDetails)() ?? {};
                const invoiceGroupId = subscriptionv2?.accountDetails?.invoiceGroupId ?? '';
                if (!transactionAccountId) throw new Error('empty transactionAccountId');
                if (!invoiceGroupId) throw new Error('empty invoiceGroupId');
                if (!entitlementId) throw new Error('empty entitlementId');
                const invoiceRequestResponse = (0, $8Jfqx.getSuccessfulResultOrThrow)(await $9bd75aff27ae6a9e$var$memoizedInvoiceRequests_get_v1({
                    fetch: (0, $f7B1p.cfetch),
                    headers: {
                        'X-transaction-account': transactionAccountId
                    },
                    queryParameters: {
                        invoiceGroup: invoiceGroupId,
                        statusFilter: 'OPEN',
                        // recommended limit of 50
                        pageRequest: {
                            pageSize: 50
                        }
                    }
                }));
                setInvoiceRequestData(invoiceRequestResponse);
                setEntitlementId(entitlementId);
            } catch (error) {
                error.message = `useInvoiceRequest: ${error.message}`;
                setError(error);
            } finally{
                setLoading(false);
            }
        };
        if (!skip) fetchData();
    }, [
        skip
    ]);
    return {
        entitlementId: entitlementId,
        invoiceRequestData: invoiceRequestData,
        error: error,
        loading: skip ? false : loading
    };
};



var $gqp7m = parcelRequire("gqp7m");


var $62guz = parcelRequire("62guz");

const $0a6ccbacaf91a55b$var$DAYS_TO_DEACTIVATION = 14;
const $0a6ccbacaf91a55b$export$8f84b2734337bf99 = (timestamp, daysToAdd)=>{
    const date = new Date(timestamp);
    if (daysToAdd) date.setDate(date.getDate() + daysToAdd);
    const difference = (0, $62guz.default)(date, new Date()) / 86400000;
    let daysLeftUntilDeactivation = difference > 0 && difference < 1 ? 0 : Math.round(difference);
    const dateString = new Date(date).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return {
        date: date,
        dateString: dateString,
        daysLeftUntilDeactivation: daysLeftUntilDeactivation
    };
};
/**
 * [CCP] Check the invoice request data to see if it falls
 * within the pre-dunning period and has the right entitlement
 */ const $0a6ccbacaf91a55b$var$getEligiblePreDunningInvoiceRequests = (ir, entitlementId)=>{
    const { status: status, items: items } = ir;
    const preDunningAttempts = ir.preDunning?.preDunningAttempts;
    return(// determines the pre-dunning status
    // filter out non-Confluence entitlement ids
    status === 'OPEN' && Boolean(preDunningAttempts?.length) && Boolean(ir.createdAt) && // @ts-ignore - outdated CCP REST autogenerated client
    !ir.invoicedAt && // @ts-ignore - outdated CCP REST autogenerated client
    !ir.uninvoiceableAt && // @ts-ignore - outdated CCP REST autogenerated client
    new Date() < new Date(ir.preDunning?.endAt) && Boolean(items?.some((item)=>item.entitlementId === entitlementId)));
};
/**
 * Extract the invoice with the earliest startedAt date
 * to calculate the deactivation date
 */ const $0a6ccbacaf91a55b$var$getEarliestPreDunningInvoiceRequest = (invoices)=>{
    if (!invoices.length) return null;
    return invoices.reduce((prev, current)=>{
        // we filter for eligible invoice requests which ensures startedAt is not empty. TS doesn't like the non-null assertion (!)
        // @ts-ignore
        return prev.preDunning.startedAt < current.preDunning.startedAt ? prev : current;
    });
};
const $0a6ccbacaf91a55b$var$memoizedGetEarliestPreDunningInvoiceRequest = (0, $2XqLN.default)($0a6ccbacaf91a55b$var$getEarliestPreDunningInvoiceRequest);
const $0a6ccbacaf91a55b$export$fb4a0fc992e01048 = ({ skip: skip } = {
    skip: false
})=>{
    const [isPreDunningPeriod, setIsPreDunningPeriod] = (0, $42omo.useState)(false);
    const [deactivationDate, setDeactivationDate] = (0, $42omo.useState)(null);
    const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $kPeHn.useCommerceBackendName)(skip);
    const skipTrialDetails = skip || commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP);
    const { data: trialDetailsData, loading: trialLoading, error: trialErr } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsPreDunningPeriodTrialDetailsQuery{license{billingSourceSystem licenseConsumingUserCount trialEndDate}}`, {
        skip: skipTrialDetails
    });
    const skipInvoiceRequest = skip || commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS);
    const { entitlementId: entitlementId, invoiceRequestData: invoiceRequestData, loading: invoiceRequestLoading, error: invoiceRequestError } = (0, $9bd75aff27ae6a9e$export$42fed8667fa5fb1c)({
        skip: skipInvoiceRequest
    });
    //Make this call only if user is in PreDunning Period
    const { hasBillingInformation: hasBillingInformation, loading: billingLoading, error: billingError } = (0, $gqp7m.useHasBillingInformation)(!isPreDunningPeriod || skip);
    const hasBilling = !billingLoading && !billingError && hasBillingInformation;
    const allLoading = commerceBackendNameLoading || billingLoading || trialLoading || invoiceRequestLoading;
    const allSkip = skipTrialDetails || skipInvoiceRequest;
    let allError = null;
    let errorSource = null;
    if (commerceBackendNameError) {
        allError = commerceBackendNameError;
        errorSource = 'commerce-backend-name';
    } else if (billingError) {
        allError = billingError;
        errorSource = 'billing-info';
    } else if (trialErr) {
        allError = trialErr;
        errorSource = 'trial-details';
    } else if (invoiceRequestError) {
        allError = invoiceRequestError;
        errorSource = 'invoice-request';
    }
    (0, $42omo.useEffect)(()=>{
        if ((!allLoading || !allError) && deactivationDate === null) {
            if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) {
                const { trialEndDate: trialEndDate } = trialDetailsData?.license || {};
                if (trialEndDate) {
                    const deactivationDateResult = $0a6ccbacaf91a55b$export$8f84b2734337bf99(trialEndDate, $0a6ccbacaf91a55b$var$DAYS_TO_DEACTIVATION);
                    const today = new Date();
                    if (new Date(trialEndDate) < today && deactivationDateResult && today < deactivationDateResult.date) {
                        setIsPreDunningPeriod(true);
                        setDeactivationDate(deactivationDateResult);
                    }
                }
            } else if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP)) {
                const data = invoiceRequestData?.data;
                if (data && entitlementId) {
                    const eligibleInvoices = data.filter((invoice)=>$0a6ccbacaf91a55b$var$getEligiblePreDunningInvoiceRequests(invoice, entitlementId));
                    const earliestPreDunningInvoice = $0a6ccbacaf91a55b$var$memoizedGetEarliestPreDunningInvoiceRequest(eligibleInvoices);
                    // @ts-ignore - outdated CCP REST autogenerated client
                    const projectedEndDate = earliestPreDunningInvoice?.preDunning?.endAt;
                    if (earliestPreDunningInvoice && projectedEndDate) {
                        setIsPreDunningPeriod(true);
                        setDeactivationDate($0a6ccbacaf91a55b$export$8f84b2734337bf99(projectedEndDate));
                    }
                }
            }
        }
    }, [
        allLoading,
        allError,
        commerceBackendName,
        entitlementId,
        trialDetailsData,
        invoiceRequestData,
        deactivationDate
    ]);
    if (allLoading || allError || hasBilling) return {
        isPreDunningPeriod: false,
        deactivationDate: null,
        error: allError,
        loading: allLoading,
        errorSource: errorSource
    };
    return {
        isPreDunningPeriod: isPreDunningPeriod,
        deactivationDate: deactivationDate,
        error: allError,
        loading: allSkip ? false : allLoading,
        errorSource: errorSource
    };
};
module.exports["useIsPreDunningPeriod"] = $0a6ccbacaf91a55b$export$fb4a0fc992e01048;

});

parcelRegister("iuUMQ", function(module, exports) {
const $8acebf0d3519a245$export$6d2d10f28cce1624 = (queryData)=>{
    const userCount = queryData?.license?.licenseConsumingUserCount;
    return userCount === undefined || userCount < 0 ? -1 : userCount;
};
module.exports["getLicenseConsumingUserCountFromQuery"] = $8acebf0d3519a245$export$6d2d10f28cce1624;

});

parcelRegister("8JJsY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");





var $inPa6 = parcelRequire("inPa6");


var $euL71 = parcelRequire("euL71");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");








var $d9tcB = parcelRequire("d9tcB");





var $bJq0d = parcelRequire("bJq0d");

const $50caaaae77d1bee4$export$aeb21c639fdc861 = (skip = false)=>{
    const { isSiteAdmin: isSiteAdmin, isAnonymous: isAnonymous } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { cloudId: cloudId, edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const meetsBaseEligibility = !isSiteAdmin && !isAnonymous && isLoggedIn && (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && (edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM) && !skip;
    // 1. determine billing system (both control & variation need to make the Commerce request)
    const { data: { license: license } = {
        license: null
    }, error: trialDetailsError, loading: trialDetailsLoading } = (0, $xQxzY.useQuery)(/** @schema cc */ (0, $eSUdr.default)`query useCanAddBillingForTrialProductUserTrialDetailsQuery{license{billingSourceSystem licenseConsumingUserCount trialEndDate}}`, {
        skip: !meetsBaseEligibility
    });
    // 2. if CCP, make commerce query and determine if they meet backend eligibility
    const { data: commerceData, error: commerceError, loading: commerceLoading } = (0, $xQxzY.useQuery)(/** @schema agg */ (0, $eSUdr.default)`query useCanAddBillingForTrialProductUserCanProductUserAddBillingQuery($cloudId:ID!$productKey:String!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:$productKey){entitlement(where:{AND:[{inTrialOrPreDunning:true}]}){transactionAccount{isCurrentUserBillingAdmin}subscription{accountDetails{invoiceGroup{invoiceable experienceCapabilities{configurePaymentV2{experienceUrl isAvailableToUser}}}}}}}}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId,
            productKey: (0, $bJq0d.MPU_QUERY).HAMS_PRODUCT_KEY
        },
        skip: !meetsBaseEligibility || license?.billingSourceSystem !== 'CCP'
    });
    const errors = [
        trialDetailsError,
        commerceError
    ];
    errors.filter((error)=>!!error).forEach((error)=>{
        !(0, $7Sm4c.isErrorMarkedAsHandled)(error) && (0, $7Sm4c.markErrorAsHandled)(error);
    });
    if (commerceError) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: 'canProductUserPay',
            source: 'useCanAddBillingForTrialProductUser',
            attributes: {
                edition: edition,
                isSiteAdmin: isSiteAdmin
            }
        }
    }).fire();
    const { isBillingAdmin: isBillingAdmin, canAddBillingDetails: canAddBillingDetails, hasBillingDetails: hasBillingDetails } = $50caaaae77d1bee4$var$parseCommerceResponse(commerceData);
    const canAddBillingForTrial = meetsBaseEligibility && license?.billingSourceSystem === 'CCP' && canAddBillingDetails && !hasBillingDetails;
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: canAddBillingForTrial ? isBillingAdmin : undefined
        }), [
        isSiteAdmin,
        canAddBillingForTrial,
        isBillingAdmin
    ]);
    return {
        loading: commerceLoading || trialDetailsLoading,
        canAddBillingForTrial: canAddBillingForTrial,
        // canAddBillingDetails lets us know that the site is either in trial OR pre-dunning
        //   Then a null trialEndDate means pre-dunning
        isPreDunning: canAddBillingDetails && license?.trialEndDate === null,
        isBillingAdmin: isBillingAdmin,
        hasBillingDetails: hasBillingDetails,
        analyticsAttributes: analyticsAttributes,
        commerceError: commerceError
    };
};
const $50caaaae77d1bee4$var$parseCommerceResponse = (data)=>{
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const transactionAccount = entitlement?.transactionAccount;
    const invoiceGroup = entitlement?.subscription?.accountDetails?.invoiceGroup;
    const configurePayment = invoiceGroup?.experienceCapabilities?.configurePaymentV2;
    return {
        isBillingAdmin: !!transactionAccount?.isCurrentUserBillingAdmin,
        canAddBillingDetails: !!configurePayment?.isAvailableToUser,
        hasBillingDetails: invoiceGroup?.invoiceable
    };
};



var $lf6uD = parcelRequire("lf6uD");




const $a4b60fb60ef548c5$var$ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $a4b60fb60ef548c5$export$c87375a1a1716424 = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, transactionAccountId: transactionAccountId } = params;
    const CLOUD_ADMIN_URL = $a4b60fb60ef548c5$var$ENV_URLS[environment ?? 'PRODUCTION'];
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS) && cloudId) return `${CLOUD_ADMIN_URL}/s/${cloudId}/billing/applications`;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && transactionAccountId) {
        if (entitlementId) return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}`;
    }
    return `${CLOUD_ADMIN_URL}/billing`;
};
const $a4b60fb60ef548c5$export$90d18295df8d3ab9 = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, invoiceGroupId: invoiceGroupId, transactionAccountId: transactionAccountId } = params;
    const CLOUD_ADMIN_URL = $a4b60fb60ef548c5$var$ENV_URLS[environment ?? 'PRODUCTION'];
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS) && cloudId) return `${CLOUD_ADMIN_URL}/s/${cloudId}/billing/paymentdetails/add`;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && transactionAccountId) {
        if (invoiceGroupId) return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/${invoiceGroupId}/payment-flow?referrer=confluence`;
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}`;
    }
    return `${CLOUD_ADMIN_URL}/billing`;
};



var $kPeHn = parcelRequire("kPeHn");

const $f1544b4355c1d0f7$var$FALLBACK_BILLING_URL = 'https://admin.atlassian.com/billing';
const $f1544b4355c1d0f7$export$3d84b9403a233360 = (skip = false)=>{
    const { environment: environment, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { canAddBillingForTrial: canAddBillingForTrial } = (0, $50caaaae77d1bee4$export$aeb21c639fdc861)();
    const isUserEligible = isSiteAdmin || canAddBillingForTrial;
    if (!isUserEligible || !cloudId) skip = true;
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [changePlanUrl, setChangePlanUrl] = (0, $42omo.useState)($f1544b4355c1d0f7$var$FALLBACK_BILLING_URL);
    const [paymentFlowUrl, setPaymentFlowUrl] = (0, $42omo.useState)($f1544b4355c1d0f7$var$FALLBACK_BILLING_URL);
    const commerceBackendData = (0, $kPeHn.useCommerceBackendName)(skip || !isSiteAdmin);
    const { loading: commerceBackendNameLoading, error: commerceBackendNameError } = commerceBackendData;
    let { commerceBackendName: commerceBackendName } = commerceBackendData;
    if (canAddBillingForTrial) commerceBackendName = (0, $6bHqX.COMMERCE_BACKEND_CCP);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (commerceBackendNameError) {
            setError(commerceBackendNameError);
            setLoading(false);
        } else if (!commerceBackendNameLoading && commerceBackendName) {
            const loadBillingDetailsUrl = async ()=>{
                try {
                    let transactionAccountId = '';
                    let entitlementId = '';
                    let subscriptionv2;
                    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP)) {
                        const result = await (0, $lf6uD.getCurrentEntitlementDetails)();
                        if (result) {
                            transactionAccountId = result.transactionAccountId;
                            subscriptionv2 = result.subscriptionv2;
                            entitlementId = result.entitlementId;
                        }
                    }
                    const invoiceGroupId = subscriptionv2?.accountDetails?.invoiceGroupId ?? '';
                    setChangePlanUrl((0, $a4b60fb60ef548c5$export$c87375a1a1716424)({
                        environment: environment,
                        commerceBackendName: commerceBackendName,
                        cloudId: cloudId,
                        entitlementId: entitlementId,
                        transactionAccountId: transactionAccountId,
                        invoiceGroupId: invoiceGroupId
                    }));
                    setPaymentFlowUrl((0, $a4b60fb60ef548c5$export$90d18295df8d3ab9)({
                        environment: environment,
                        commerceBackendName: commerceBackendName,
                        cloudId: cloudId,
                        entitlementId: entitlementId,
                        transactionAccountId: transactionAccountId,
                        invoiceGroupId: invoiceGroupId
                    }));
                } catch (error) {
                    error.message = `useBillingUrls: ${error.message}`;
                    setError(error);
                } finally{
                    setLoading(false);
                }
            };
            loadBillingDetailsUrl();
        }
    }, [
        commerceBackendNameLoading,
        commerceBackendNameError,
        commerceBackendName,
        cloudId,
        environment,
        skip
    ]);
    return {
        changePlanUrl: changePlanUrl,
        paymentFlowUrl: paymentFlowUrl,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useBillingUrls"] = $f1544b4355c1d0f7$export$3d84b9403a233360;

});

parcelRegister("7XaXR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6bHqX = parcelRequire("6bHqX");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $31e5e2436b65a0d6$export$9e0e01d4f9f95e63 = ({ isReverseTrialer: isReverseTrialer, edition: edition, isInTrial: isInTrial = false, isInPredunning: isInPredunning = false, hasBillingInformation: hasBillingInformation, commerceBackendName: commerceBackendName, isPlanSelectionPageUrlAvailable: isPlanSelectionPageUrlAvailable })=>Boolean(edition === (0, $euL71.ConfluenceEdition).PREMIUM && (isInTrial || isInPredunning) && isReverseTrialer && hasBillingInformation === false && commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && isPlanSelectionPageUrlAvailable);
const $31e5e2436b65a0d6$export$7c42f4ccf12358bc = ({ isEligible: isEligible, touchpointId: touchpointId, attributes: attributes })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [premiumReverseTrialABCohort, setPremiumReverseTrialABCohort] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (isEligible && (0, $9wGTI.fg)('growth_confluence_buy_reverse_trials_fg')) setPremiumReverseTrialABCohort((0, $6mKj3.expVal)('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled'));
        else if (!premiumReverseTrialABCohort) setPremiumReverseTrialABCohort('not-enrolled');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEligible
    ]);
    (0, $42omo.useEffect)(()=>{
        if (premiumReverseTrialABCohort === 'control' || premiumReverseTrialABCohort === 'variation') createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: 'growth_confluence_buy_reverse_trials_ab-exposed',
                attributes: {
                    cohort: premiumReverseTrialABCohort,
                    touchpointId: touchpointId,
                    ...attributes
                },
                source: 'growth_confluence_buy_reverse_trials_ab'
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        premiumReverseTrialABCohort
    ]);
    return premiumReverseTrialABCohort;
};
module.exports["useIsEligibleForPremiumReverseTrialsExperiment"] = $31e5e2436b65a0d6$export$9e0e01d4f9f95e63;
module.exports["usePremiumReverseTrialABCohort"] = $31e5e2436b65a0d6$export$7c42f4ccf12358bc;

});

parcelRegister("53KZp", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 **/ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $6Co6F = parcelRequire("6Co6F");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");

const $e6926c0a8d4b0c09$var$getCommerceUrlWithAltOrigin = (experienceUrl)=>{
    if (!experienceUrl) return '';
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    const url = origin.addToUrl(experienceUrl);
    return url.toString();
};
function $e6926c0a8d4b0c09$export$f6c7eb82c8541ea({ skip: skip = false } = {}) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, error: error, loading: loading } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePlanSelectionPageInfoQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:"confluence.ondemand"){...on CommerceEntitlementInfoCcp{entitlementId entitlement{...on CcpEntitlement{id}experienceCapabilities{...on CcpEntitlementExperienceCapabilities{changeOfferingV2{isAvailableToUser experienceUrl}}}}}}}}`, {
        variables: {
            cloudId: cloudId
        },
        skip: !cloudId || skip,
        client: (0, $gKr8t.getAGGClient)()
    });
    const changeOfferingV2 = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOfferingV2;
    const isAvailableToUser = changeOfferingV2?.isAvailableToUser;
    const changeOfferingExperienceUrl = changeOfferingV2?.experienceUrl;
    const planSelectionPageUrl = (0, $42omo.useMemo)(()=>{
        return $e6926c0a8d4b0c09$var$getCommerceUrlWithAltOrigin(changeOfferingExperienceUrl);
    }, [
        changeOfferingExperienceUrl
    ]);
    if (!cloudId || skip) return {
        isAvailableToUser: false,
        planSelectionPageUrl: undefined,
        loading: false,
        error: null
    };
    return {
        isAvailableToUser: isAvailableToUser,
        planSelectionPageUrl: planSelectionPageUrl,
        loading: loading,
        error: error
    };
}
module.exports["usePlanSelectionPageInfo"] = $e6926c0a8d4b0c09$export$f6c7eb82c8541ea;

});

parcelRegister("5lbXZ", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $kAcNG = parcelRequire("kAcNG");


var $6mKj3 = parcelRequire("6mKj3");

const $f339013c39d2997d$export$2806310bbbb1f628 = ({ isSiteAdmin: isSiteAdmin, edition: edition, hasBillingInformation: hasBillingInformation, isInTrialOrPredunning: isInTrialOrPredunning, commerceBackendName: commerceBackendName, source: source, skip: skip, analyticAttributes: analyticAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldCheckIfAutoUpgrade = isSiteAdmin && edition === (0, $d9tcB.ConfluenceEdition).STANDARD && !hasBillingInformation && commerceBackendName === 'CCP' && isInTrialOrPredunning;
    const { loading: loading, error: error, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skip || !shouldCheckIfAutoUpgrade
    });
    const isAutoUpgrade = !!attributes.find((attribute)=>attribute.name === 'confluence_ccp_auto_upgraded_trialing_and_predunning_sites');
    if (error) {
        const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            product: (0, $gwZbZ.Product).CONFLUENCE,
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            experimentMeta: {
                experimentKey: 'auto_upgrade_not_a_trial'
            },
            errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
            errorMessage: error.message,
            source: `useSitePersonalizationQuery hook`,
            severity: (0, $gwZbZ.Severity).HIGH
        });
        createAnalyticsEvent(eventPayload).fire();
    }
    let autoUpgradeNotATrialExperimentCohort = 'not-enrolled';
    if (!loading && !error && isAutoUpgrade) {
        // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
        autoUpgradeNotATrialExperimentCohort = (0, $6mKj3.UNSAFE_expValNoExposure)('auto_upgrade_not_a_trial', 'cohort', 'not-enrolled');
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                actionSubjectId: 'autoUpgradeNotATrialExperiment',
                attributes: {
                    autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort,
                    ...analyticAttributes
                },
                source: source
            }
        }).fire();
    }
    return {
        loading: loading,
        error: error,
        autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort
    };
};
module.exports["useAutoUpgradeNotATrialExperiment"] = $f339013c39d2997d$export$2806310bbbb1f628;

});

parcelRegister("cN2XO", function(module, exports) {
const $76ee52796b52b71a$var$getLinkToAdminHub = (environment)=>{
    if (environment === 'PRODUCTION') return 'https://admin.atlassian.com';
    return 'https://admin.stg.atlassian.com';
};
const $76ee52796b52b71a$export$4dc1461fa9ef6178 = (environment, orgId, path)=>{
    if (!orgId) return '';
    return `${$76ee52796b52b71a$var$getLinkToAdminHub(environment)}/o/${orgId}${path}`;
};
module.exports["linkToAdminHubOrg"] = $76ee52796b52b71a$export$4dc1461fa9ef6178;

});

parcelRegister("4LS1B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $gdv5Z = parcelRequire("gdv5Z");


var $fAD9L = parcelRequire("fAD9L");


var $7wGk4 = parcelRequire("7wGk4");


var $5EhYK = parcelRequire("5EhYK");


var $dhYWb = parcelRequire("dhYWb");


var $b0bCf = parcelRequire("b0bCf");


var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $geuBO = parcelRequire("geuBO");


const $1a75403b0ddf04e4$export$4bb2f50ec3b65671 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("4CaS8")), {
        moduleId: "7ec823a3",
        priority: "interaction",
        moduleId: 'avoid-deactivation-data-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, touchpointId: touchpointId, onError: onError, product: product })=>({
            entryPoints: {},
            extraProps: {
                touchpointId: touchpointId,
                onError: onError,
                product: product
            },
            queries: {
                avoidDeactivation: {
                    parameters: (0, $geuBO.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});


function $f56251f2f792e797$export$1e9bb993162ae27b({ product: product, cloudId: cloudId, touchpointId: touchpointId, children: children, onError: onError, onClose: onClose, renderWithWrapperAnalytics: renderWithWrapperAnalytics = false }) {
    const { createTakeActionClickEvent: createTakeActionClickEvent } = (0, $5EhYK.useAnalytics)();
    const entryPointParams = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $b0bCf.getHamsKey)(product),
            product: product,
            touchpointId: touchpointId,
            onClose: onClose,
            onError: onError
        }), [
        cloudId,
        product,
        onError,
        onClose,
        touchpointId
    ]);
    const modalProps = (0, $42omo.useMemo)(()=>({
            onError: onError,
            onClose: onClose,
            touchpointId: touchpointId
        }), [
        onError,
        onClose,
        touchpointId
    ]);
    const fireClickAnalytics = ()=>{
        createTakeActionClickEvent((0, $dhYWb.TAKE_ACTION_SOURCE_ID), {
            product: product,
            touchpointId: touchpointId
        });
    };
    const handleTriggerClick = (_event)=>{
        fireClickAnalytics();
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            fireClickAnalytics();
        }
    };
    /**
	 * renderWithWrapperAnalytics is used to determine if the children should be wrapped in a Box component
	 * or a button component. AkFlags render their Actions as buttons, so rendering a child as a button violates a11y rules in jira.
	 * If the child is not a button, we render it as a Box component to avoid this issue.
	 */ return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            attributes: {
                product: product,
                touchpointId: (0, $dhYWb.AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID)
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fAD9L.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7wGk4.ModalTrigger), {
                entryPoint: (0, $1a75403b0ddf04e4$export$4bb2f50ec3b65671),
                entryPointParams: {
                    ...entryPointParams,
                    ...modalProps
                },
                onError: onError,
                children: ({ ref: ref })=>renderWithWrapperAnalytics ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        ref: ref,
                        children: children
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        ref: ref,
                        role: "button",
                        tabIndex: 0,
                        onClick: handleTriggerClick,
                        onKeyDown: handleKeyDown,
                        children: children
                    })
            })
        })
    });
}
module.exports["AutoUpgradeAvoidDeactivationModal"] = $f56251f2f792e797$export$1e9bb993162ae27b;

});

parcelRegister("geuBO", function(module, exports) {
/**
 * @generated SignedSource<<9d70c296f91dbb02349b6dc4a854d6c4>>
 * @relayHash 437f7d72ff42094579694ac45f79db57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 731366b8feabd6553bc0ff57a014205d991ec059e14df4d2521b458439e87588

var $3e6Uc = parcelRequire("3e6Uc");

const $20c0a6c8cb3baf0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "orgId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "quantity"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "firstPreDunningEndTimestampV2"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = [
        v10 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "avoidDeactivationDataModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "chargeDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "chargeQuantities",
                                                            "plural": true,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "avoidDeactivationDataModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "trial",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v11 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "chargeDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "chargeQuantities",
                                                            "plural": true,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                v6 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "preDunning",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "731366b8feabd6553bc0ff57a014205d991ec059e14df4d2521b458439e87588",
            "metadata": {},
            "name": "avoidDeactivationDataModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$20c0a6c8cb3baf0a$var$node.hash = "b8af245628ebfef774f1a52547983971";
(0, $3e6Uc.PreloadableQueryRegistry).set($20c0a6c8cb3baf0a$var$node.params.id, $20c0a6c8cb3baf0a$var$node);
var $20c0a6c8cb3baf0a$export$2e2bcd8739ae039 = $20c0a6c8cb3baf0a$var$node;
module.exports["default"] = $20c0a6c8cb3baf0a$export$2e2bcd8739ae039;

});

parcelRegister("4CaS8", function(module, exports) {

let $35c3250586899c2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35c3250586899c2d$var$load("dTsOE"),
    $35c3250586899c2d$var$load("4zlcK")
]).then(()=>parcelRequire('bfw3B'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("lf6uD", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $8Jfqx = parcelRequire("8Jfqx");





var $c0rhi = parcelRequire("c0rhi");


var $f7B1p = parcelRequire("f7B1p");


var $dIHBW = parcelRequire("dIHBW");

const $8b8027872473808f$var$memoizedEntitlementsDetails_get_byEntitlementId_v1 = (0, $2XqLN.default)((0, $8Jfqx.entitlementsDetails_get_byEntitlementId_v1), ([{ pathParameters: { entitlementId: newEntitlementId } }], [{ pathParameters: { entitlementId: lastEntitlementId } }])=>{
    return newEntitlementId === lastEntitlementId;
});
const $8b8027872473808f$export$a0b078db5da2a026 = async ()=>{
    // get current tenant's entitlement id
    const entitlementIdQuery = await (0, $c0rhi.queryInterop)({
        query: (0, $dIHBW.default)
    });
    const entitlementId = entitlementIdQuery?.data?.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || '';
    if (!entitlementId) throw new Error('empty entitlementId');
    // get the entitlement details
    const entitlementDetails = (0, $8Jfqx.getSuccessfulResultOrThrow)(await $8b8027872473808f$var$memoizedEntitlementsDetails_get_byEntitlementId_v1({
        fetch: (0, $f7B1p.cfetch),
        pathParameters: {
            entitlementId: entitlementId
        }
    }));
    return entitlementDetails;
};
module.exports["getCurrentEntitlementDetails"] = $8b8027872473808f$export$a0b078db5da2a026;

});

parcelRegister("dIHBW", function(module, exports) {
/**
 * @generated SignedSource<<4f7afa86052f404ee8050cf4cc207490>>
 * @relayHash 618925ecd171e10c47bc48fb1f7155a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18a0da3d4a018599a3b7e9bcb64ed2b338d1a980eef545cd22752ab239e174df
const $d8435c2cd1dd8864$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicenseStates",
                    "kind": "LinkedField",
                    "name": "licenseStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LicenseState",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ccpEntitlementId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "CcpEntitlementIdQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "CcpEntitlementIdQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "618925ecd171e10c47bc48fb1f7155a3",
            "id": "18a0da3d4a018599a3b7e9bcb64ed2b338d1a980eef545cd22752ab239e174df",
            "metadata": {},
            "name": "CcpEntitlementIdQuery",
            "operationKind": "query",
            "text": "query CcpEntitlementIdQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}}"
        }
    };
}();
$d8435c2cd1dd8864$var$node.hash = "3800703c56d88a50d87f006b3cc20b97";
var $d8435c2cd1dd8864$export$2e2bcd8739ae039 = $d8435c2cd1dd8864$var$node;
module.exports["default"] = $d8435c2cd1dd8864$export$2e2bcd8739ae039;

});


//# sourceMappingURL=GracePeriodBanner.7a01e606.js.map
